export default {
  ACCEPTED_FORMATS: '(Formats acceptés : JPEG, PNG, JPG)',
  ACCOUNTING_CODE: 'Code comptable',
  ACTIONS: 'Actions',
  ACTIVE: 'Actif',
  ADD: 'Ajouter',
  ADD_SUPPLIER: 'Ajouter un fournisseur',
  ADD_TAX: 'Ajouter la taxe ',
  ADD_NEW_TAX: 'Ajouter une nouvelle taxe',

  ADDING_NEW_CATEGORY_DETAILS:
    "Ajout des détails d'une nouvelle catégorie en cours ...",
  ADDING_NEW_SUB_CATEGORY_DETAILS:
    "Ajout des détails d'une nouvelle sous-catégorie en cours ...",
  ADDING_NEW_SUPPLIER_DETAILS:
    "Ajout des détails d'un nouveau fournisseur en cours ...",

  ADDRESS: 'Adresse',
  ADMIN_PROFILE: 'Profil Administrateur',
  APPLY: 'Appliquer',
  AUTHENTICATING: 'Authentification en cours ...',

  BACKORDER: 'Commande en attente',
  BAKEASY_ADMIN_PORTAL: 'Portail Administrateur Order-EZ',
  BILL_TO: 'Facturé à',
  BILL_TO_COUNTRY: 'Facturer à Pays',
  BILL_TO_NAME: 'Nom',
  BILLING: 'Facture',
  BILLING_DETAILS: 'Détails de la facture',

  CANCEL: 'Annuler',
  CATEGORY: 'Catégorie',
  CHAIN_STORE_NAME: 'Nom de la chaîne de magasins',
  CHAIN_STORE_PARENT: 'Chaîne de magasins/Société mère',
  CHANGE_PASSWORD: 'Changer le mot de passe',
  CITY: 'Ville',

  COMPANY_ADDRESS: 'Adresse de la compagnie',
  COMPANY_NAME: 'Nom compagniee',
  COMPOSE: 'Composer',

  CONFIRM_PASSWORD: 'Confirmer le mot de passe',
  CONTACT: 'Contact',
  CONTACT_ACCOUNTING: 'Contact comptabilité',
  CONTACT_STORE: 'Contact Client',
  CONTACT_SUPPLIER: 'Contact fournisseur',
  CONTACT_SUPPORT: 'Veuillez contacter le support technique du système',
  CONTACT1: 'Contact 1',
  CONTACT2: 'Contact 2',

  CONTENT: 'Contenu',
  CREATE: 'Créer',
  CREATED_DATE: 'Date de création',
  COUNTRY: 'Pays',
  CURRENT_PASSWORD: 'Mot de passe actuel',

  DATE: 'Date',
  DATE_CREATED: 'Date de création',
  DATE_MM_DD_YYYY: 'Date',
  DATE_REGISTERED: "Date d'enregistrement",
  DEACTIVATE: 'DÉSACTIVER',
  DEACTIVATE_SUPPLIER: 'Désactiver le fournisseur',
  DEACTIVATE_SUPPLIER_MESSAGE:
    'Êtes-vous sûr(e) de vouloir désactiver le fournisseur',
  DEACTIVATING_SUPPLIER: 'Désactivation du fournisseur...',
  DEACTIVE: 'Désactivé',
  DELETE: 'Supprimer',
  DELETE_MESSAGE: 'Supprimer message',
  DELETE_MESSAGE_CONFIRMATION:
    'Êtes-vous sûr(e) de vouloire supprimer ce message?',
  DELETING_MESSAGE: 'Suppression du message',
  DESCRIPTION: 'Description',
  DIFFERENT_LEGAL_NAME: 'Nom légal différent',
  DISCOUNT: 'Remise',
  DISCOUNT_PER: 'Remise % du prix du détail',

  DOWNLOAD_FAILURE: 'Échec de téléchargement',
  DOWNLOAD_SUCCESS: 'Succès du téléchargement',
  DOWNLOADING_STORE: 'Téléchargement Client en cours ...',
  DOWNLOADING_STORE_DETAILS: 'Téléchargement détails Client en cours ...',
  DOWNLOADING_SUBCATEGORIES: 'Téléchargement des sous-catégories...',
  DOWNLOADING_SUPPLIER_LIST: 'Téléchargement de la liste des fournisseurs...',
  DUPLICATE: 'Reproduire',

  EDIT: 'Éditer',
  EDIT_SUPPLIER: 'Éditer le fournisseur',
  EMAIL: 'Adresse e-mail',
  EMAIL_ID: 'Identifiant e-mail',

  ENTER: 'Éditer ',
  ENTER_ACCOUNTING_CODE: 'Saisir le code comptable',
  ENTER_CHAIN_STORE_NAME: 'Saisir le nom de la chaîne de magasins',
  ENTER_EMAIL_ID: "Saisir l'identifiant e-mail",
  ENTER_FIRST_NAME: 'Saisir le prénom',
  ENTER_LAST_NAME: 'Saisir le nom de famille',
  ENTER_LEGAL_NAME: 'Saisir le nom légal',
  ENTER_MESSAGE: 'Saisir le message',
  ENTER_NAME: 'Saisir le nom',
  ENTER_MASTER_PASSWORD: 'Saisir le mot de passe principal',
  ENTER_MOBILE_NUMBER: 'Saisir le numéro de téléphone portable',

  ENTER_PARENT_ADDRESS: "Saisir l'adresse de la société mère",
  ENTER_PARENT_CITY: 'Saisir la ville de la société mère',
  ENTER_PARENT_COUNTRY: 'Saisir le pays de la société mère',
  ENTER_PARENT_STATE: 'Saisir l’État/la province de la société mère',
  ENTER_PARENT_POSTAL_CODE: 'Saisir le code postal de la société mère',

  ENTER_PASSWORD: 'Saisir le mot de passe',
  ENTER_PHONE_NUMBER: 'Saisir le numéro de téléphone',

  ENTER_SUPPLIER_CITY: 'Saisir la ville du fournisseur',
  ENTER_SUPPLIER_COUNTRY: 'Saisir le pays du fournisseur',
  ENTER_SUPPLIER_NAME: 'Saisir le nom du fournisseur',
  ENTER_SUPPLIER_STATE: 'Saisir l’État / la province du fournisseur',
  ENTER_SUPPLIER_POSTAL_CODE: 'Saisir le code postal du fournisseur',

  ENTER_USER_NAME: "Saisir le nom d'utilisateur",
  ENTER_WORK: 'Saisir le travail',
  ENTER_YOUR_EMAIL: 'Saisir votre e-mail',
  ENTER_YOUR_PASSWORD: 'Saisir votre mot de passe',
  ENTER_YOUR_USERNAME: "Saisir vore nom d'utilisateur",
  EXPORT: 'Exportation',

  FETCHING_CATEGORIES: 'Recherche des catégories...',
  FETCHING_CATEGORIES_DETAILS: 'Recherche des détails des catégories...',
  FETCHING_CITIES: 'Recherche des villes...',
  FETCHING_COUNTRIES: 'Récupération des pays en cours ...',
  FETCHING_MESSAGE_STATUS: "Recherche de l'état du message...",
  FETCHING_MESSAGES: 'Recherche des messages...',
  FETCHING_NAMES: 'Recherche des noms...',
  FETCHING_PRODUCTS: 'Recherche des produits...',
  FETCHING_PRODUCTS_DETAILS: 'Recherche des détails des produits...',
  FETCHING_REPLIES: 'Recherches des réponses...',
  FETCHING_SUBCATEGORIES: 'Recherche des sous-catégories...',
  FETCHING_STATES: 'Recherches des États...',
  FETCHING_STORES: 'Recherche Clients en cours …',
  FETCHING_STORES_DETAILS: 'Recherche détails Clients en cours…',
  FETCHING_SUPPLIERS: 'Recherche des fournisseurs...',
  FETCHING_SUPPLIER_DETAILS: 'Recherche des détails du fournisseur...',
  FETCHING_TAX: 'Recherche des taxes...',

  FILE_SIZE_MSG:
    'La taille du fichier dépasse la limite de 2 Mo. Veuillez choisir un fichier plus petit',
  FILTER: 'Filtre',
  FIRST_NAME: 'Prénom',
  FORGOT_PASSOWRD: 'Mot de passe oublié ?',
  FROM: 'De',

  GETTING_USER_PROFILE: 'Obtention du profil utilisateur...',

  IMAGE: 'Image',
  INACTIVE: 'Inactif',
  INGREDIENT_IMAGE: "Image de l'étiquette des ingrédients",
  INGREDIENT_NAME: "Nom de l'ingrédient",
  INGREDIENTS: 'Ingrédients',
  IS_NOT_SAME: "N'est pas le même",
  IS_REQUIRED: 'est requis',
  INVOICE_DETAILS: 'Détails Facture',

  LANGUAGE: 'Langue',
  LANGUAGES: 'Langues',
  LAST_ACCESS: 'Dernier accès',
  LAST_ACCESS_DATE: 'Date du dernier accès',
  LAST_ORDER_DATE: 'Date de la dernière commande',
  LAST_NAME: 'Nom de famille',
  LEGAL_NAME: 'Nom légal',
  LOGIN_SUCCESS_MSG: 'Connexion réussie',
  LOGOUT: 'Déconnexion',

  MASTER_PASSWORD: 'Mot de passe principal',
  MASTER_PASSWORD_UPDATED_SUCCESSFULLY_LOGGING_OUT:
    'Mot de passe principal mis à jour avec succès, déconnexion...',
  MEASURE_PER_UNITS: 'Mesure par unité',

  MEASURE_TYPE: 'Type de mesuree',
  MESSAGE_COMPOSE: "Rédaction d'un message",
  MESSAGE_FILTERS: 'Filtres message',
  MESSAGE_FROM: 'Message de',
  MESSAGE_IS_REQUIRED: 'Message requis',
  MESSAGE_TO: 'Message à',
  MESSAGES: 'Messages',
  MESSAGES_THREAD: 'Fil de messages',

  METHOD: 'Méthode',
  MOBILE: 'Téléphone mobile',
  MODIFYING_LANGUAGE: 'Modification de la langue...',
  MODIFYING_PROFILE: 'Modification du profil...',
  MODIFYING_SUPPLIER_DETAILS: 'Modification des détails du fournisseur...',

  NAME: 'Nom',
  NEW: 'Nouveau',
  NEW_MESSAGE: 'Nouveau message',
  NEW_PASSWORD: 'Nouveau mot de passe',
  NO: 'Non',
  NO_DATA_FOUND: 'Aucune donnée disponible',
  NO_YES: 'Oui / Non',
  NORMAL: 'Normale',
  NOT_APPLICABLE: 'Not Applicable',
  NUTRITION_IMAGE: "Image de l'étiquette nutritionnelle",

  OK: 'Ok',
  VIEW_REPLY: 'Voir / Répondre',
  OLD_PASSWORD: 'Ancien mot de passe',
  OTHER_DETAILS: 'Autres détails',
  ORDERS: 'Commandes',

  PARENT_ADDRESS: 'Adresse de la société mère',
  PARENT_CITY: 'Ville de la société mère',
  PARENT_COUNTRY: 'Pays de la société mère',
  PARENT_EMAIL_ID: 'Adresse e-mail de la société mère',
  PARENT_POSTAL_CODE: 'Code postal de la société mère',
  PARENT_POSTAL_CODE_ZIP: 'Code postal de la société mère',
  PARENT_STATE: 'l’État/la province de la société mère',
  PARENT_WORK: 'Projet principal',
  PARENT_WORK_NUMBER: 'Téléphone Travail Société mère',

  PASSWORD: 'Mot de passe',
  PASSWORD_IS_REQUIRED: 'Mot de passe requis',
  PASSWORD_MIN_LENGTH_ERROR: 'Doit contenir 5 caractères minimum',
  PASSWORD_UPDATED_SUCCESSFULLY_LOGGING_OUT:
    'Mot de passe principal mis à jour avec succès, déconnexion...',
  PAYMENT: 'Paiement',
  PHONE: 'Téléphone',

  PLEASE_ENTER_DESCRIPTION: 'Veuillez saisir la description',
  PLEASE_ENTER_SUBJECT: 'Veuillez saisir le sujet',
  PLEASE_ENTER_VALID: 'Veuillez vérifier la validité du ',
  PLEASE_ENTER_VALID_CREDINALS: 'Veuillez saisir des références valides',
  PLEASE_FILL_ALL_FEILDS_BEFORE_SENDING_THE_MESSAGE:
    "Veuillez remplir tous les champs avant d'envoyer le message",
  PLEASE_SELECT_NAME: 'Veuillez sélectionner un nom',
  PLEASE_TYPE_REACTIVATE: 'Veuillez taper REACTIVATE',
  PLEASE_UPLOAD:
    "Veuillez télécharger une image d'une taille inférieure à 2 MB",

  PREFERRED_SHIPPING_METHOD: "Mode d'expédition souhaité",
  PRICE: 'Prix',
  PRINT: 'Imprimer',
  PRIORITY: 'Priorité',

  PRODUCT: 'Produit',
  PRODUCT_DETAILS: 'Détails du produit',
  PRODUCT_FILTER: 'Filtre produit',
  PRODUCT_ID: 'Identifiant du produit',
  PRODUCT_IMAGE: 'Image Produit',
  PRODUCT_NAME: 'Nom du produit',
  PRODUCT_QUANTITY: 'Quantité du produit',
  PRODUCT_STATUS: 'Statut du produit',
  PRODUCT_TYPE: 'Type du produit',
  PRODUCTS: 'Produits',

  PROFILE: 'Profil',
  PROFILE_SETTINGS: 'Profil et paramètres',
  PROVINCE: 'Province',

  QR_CODE: 'Code QR',
  QUANTITY_PER_UNIT: 'Quantité par unité',

  RATE_1: 'Taux 1',
  RATE_2: 'Taux 2',

  REACTIVATE: 'RÉACTIVER',
  REACTIVATE_SUPPLIER: 'Réactiver fournisseur',
  REACTIVATE_SUPPLIER_MESSAGE:
    'Êtes-vous sûr(e) de vouloir réactiver ce fournisseur ?',
  REACTIVATING_SUPPLIER: 'Réactivation du fournisseur...',
  REACTIVE: 'Réactivé',
  READ: 'Lu',
  REC_SENT: 'Reçu-envoyé',
  RECIPE_BUILDER: 'Créateur de recettes',
  RECIPE_BUILDER_TYPE: 'Type de créateur de recettes',
  RECIPE_BUILDER_REPORT: 'Rapport du créateur de recettes',
  REMEMBER_ME: 'Se souvenir de moi',
  REPLY: 'Répondre',
  RETAIL_PRICE: 'Prix de détail',
  ROWS_PER_PAGE: 'Rows per page',

  SAVE: 'Sauvegarder',
  SAVE_CHANGES: 'Enregistrer les modifications',
  SEARCH: 'Rechercher',

  SELECT: 'Sélectionner ',
  SELECT_BILL_TO: 'Sélectionner le destinataire de la facture',
  SELECT_CATEGORY: 'Sélectionner la catégorie',
  SELECT_FROM: 'Sélectionner parmi',
  SELECT_LANGUAGE: 'Sélectionner la langue',
  SELECT_TO: 'Sélectionner pour',
  SELECT_RECIPE_BUILDER: 'Sélectionner le créateur de recettes',

  SEND: 'Envoyer',
  SEND_RECEIVE: 'Envoyer/Recevoir',
  SENDING_MESSAGES: 'Envoi de messages...',
  SENDING_REPLIES: 'Envoi de réponses...',
  SENT: 'Envoyé',

  SET_AS_HIGH_PRIORITY: 'Priorité élevée',
  SET_MASTER_PASSWORD: 'Définir le mot de passe principal',
  SET_PASSWORD: 'Définir le mot de passe',
  SETUP_FEE: 'Frais de configuration',

  SHIP_TO: 'Expédier à',
  SHIPPING_CALCULATION: "Calcul de l'expédition",
  SHIPPING_CHARGE: "Tarif d'expédition",
  SHIPPING_CHARGES: "Tarifs d'expédition",
  SHIPPING_DETAILS: "Détails d'expédition",
  SHIPPING_METHOD: "Méthode d'expédition",
  SHIPPING_RATE: "Frais d'expédition",

  SIGN_IN: 'Se connecter',
  SIGN_IN_PORTAL: 'Portail de connexion Administrateur à Order-EZ',

  SKU_IMAGE: 'Image UGS',
  SKU_NUMBER: 'Numéro UGS (Unité de Gestion de Stock)',

  STATE: 'État',
  STATUS: 'Statut',

  STORE: 'Client',
  STORE_ADDRESS: 'Adresse Client',
  STORE_CITY: 'Ville Client',
  STORE_CONTACT: 'Contact Client',
  STORE_COUNTRY: 'Pays Client',
  STORE_ID: 'Identifiant Client',
  STORE_DETAILS: 'Détails Client',
  STORE_FILTER: 'Filtre Client',
  STORE_FILTERS: 'Filtres Client',
  STORE_LOGO: 'Logo Client',
  STORE_NAME: 'Nom Client',
  STORE_POSTAL_CODE: 'Code postal/ZIP du client',
  STORE_STATE: 'État/Province Client',
  STORE_TAX1: 'Nom de la taxe Client (1)',
  STORE_TAX1_RATE: 'Nom de la taxe Client (1)',
  STORE_TAX2: 'Nom de la taxe Client (2)',
  STORE_TAX2_RATE: 'Nom de la taxe Client (2)',
  STORES: 'Clients',
  STORE_STATE_PROVINCE: 'État/Province Client',
  SUB_CATEGORY: 'Sous-catégorie',
  SUBJECT: 'Objet',
  SUBCATEGORY: 'Sous-catégorie',
  SUBSCRIPTION_PACK: "Pack d'abonnement",

  SUPPLIER_ADDRESS: 'Adresse du fournisseur',
  SUPPLIER_CITY: 'Ville du fournisseur',
  SUPPLIER_CONTACT: 'Contact du fournisseur',
  SUPPLIER_COUNTRY: 'Pays du fournisseur',
  SUPPLIER_DETAILS: 'Détails du fournisseur',
  SUPPLIER_EMAIL: 'E-mail Fournisseur',
  SUPPLIER_ID: "Numéro d'identification",
  SUPPLIER_NAME: 'Nom du fournisseur',
  SUPPLIER_FILTER: 'Filtre fournisseur',
  SUPPLIER_LOGO: 'Logo du fournisseur',
  SUPPLIER_POSTAL_CODE: 'Code postal du fournisseur',
  SUPPLIER_PROVINCE: 'FSupplier Province', //not used
  SUPPLIER_STATE: 'État du fournisseur',
  SUPPLIER_TAX1: "Numéro d'identification fiscal administrateur (1)",
  SUPPLIER_TAX1_RATE: 'Taux de taxe du fournisseur (1)',
  SUPPLIER_TAX2: "Numéro d'identification fiscal administrateur (2)",
  SUPPLIER_TAX2_RATE: 'Taux de taxe du fournisseur (2)',
  SUPPLIER_WORK: 'Fournisseur travail',
  SUPPLIERS: 'Fournisseurs',
  SUPPLIER_STATE_PROVINCE: 'Fournisseur État/Province',
  STATE_PROVINCE: 'État/Province',

  TAG: 'Étiquette',
  TAX_DESCRIPTION: 'Description de la taxe',
  TAX_NUMBER1: "Numéro d'identification fiscal 1",
  TAX_NUMBER2: "Numéro d'identification fiscal 2",
  TAX_RATE: "Taux d'imposition",
  TAX1: 'FTax 1', //not used
  TAX2: 'FTax 2', //not used
  TAXES: 'Taxes',
  TERMS: 'Conditions',
  TO: 'À',
  TO_ALL_SUPPLIERS: 'À tous les fournisseurs',
  TOTAL_ORDER_VALUE: 'Valeur totale de la commande',
  TOTAL_ORDERS: 'Total des commandes',
  TOTAL_REQUIRED: 'Total requis',

  TYPE_DEACTIVATE_HERE: 'Taper DEACTIVATE ici',
  TYPE_REACTIVATE_HERE: 'Taper REACTIVATE ici',

  UNIT_OF_MEASURE: 'Unités de mesure',
  UPDATE: 'Mise à jour',
  UPDATE_CATEGORY_DETAILS: 'Mise à jour des détails de la catégorie...',
  UPDATING_SUBCATEGORIES_DETAILS:
    'Mise à jour des détails de la sous-catégorie...',
  UPLOAD: 'Télécharger',
  UPLOADING_LOGO: 'Téléversement Logo en cours ...',
  UPLOADING_PROFILE_IMAGE: "Téléchargement de l'image du profil...",

  URGENT: 'Urgent',
  USERNAME: "Nom d'utilisateur",
  USER_NAME: "Nom d'utilisateur",

  VALUES: 'Valeurs',
  VERSION: 'Version',
  YES: 'Oui',
  WORK: 'Travail',
  YOU_MUST_COMPLETE_ALL_REQUIRED_FEILDS_OR_CHANGES_WILL_BE_LOST:
    'Vous dois Complétez tous les chiffres obligatoires ou les changements seront perdus',
  BACK: 'Dos',
  CONTINUE: 'continuer',
  NOTE_YOU_CAN_ENTER_UP_TO_500_CHARACTERS:
    'Remarque : vous pouvez saisir jusqu’à 500 caractères.',
  PLEASE_ENTER_VALID_PARENT_CITY: 'Veuillez saisir la ville de la société mère',
  ENTER_VALID_ACCOUNTG_CODE: 'Veuillez saisir Code comptable valide',
  PLEASE_ENTER_VALID_USERNAME: "Veuillez saisir un nom d'utilisateur valide",
  PLEASE_ENTER_VALID_SUPPLIER_NAME:
    'Veuillez saisir un nom du fournisseur valide',
  PLEASE_ENTER_VALID_EMAIL: 'Veuillez saisir une addresse e-mail valide',
  PLEASE_ENTER_VALID_FIRST_NAME: 'Veuillez saisir un prénom valide',
  PLEASE_ENTER_VALID_LAST_NAME: 'Veuillez saisir un nom de famille',
  PLEASE_ENTER_VALID_WORK_NUMBER:
    'Veuillez saisir un numéro de téléphone au travail valide',
  PLEASE_ENTER_SUPPLIER_TAX1:
    'Veuillez saisir une taxe administrative 1 valide',
  PLEASE_ENTER_SUPPLIER_TAX2:
    'Veuillez saisir une taxe administrative 2 valide',
  PLEASE_ENTER_VALID_MOBILE:
    'Veuillez saisir un numéro de téléphone mobile valide',
  PLEASE_ENTER_COMPANY_NAME: 'Veuillez saisir un nom de compagnie valide',
  PLEASE_ENTER_VALID_SUPPLIER_POSTAL_CODE:
    'Veuillez saisir un code postal du fournisseur valide',
  PLEASE_ENTER_VALID_SUBJECT: 'Veuillez saisir un objet valide',
  ENTER_SUPPLIER_ADDRESS: "Saisir l'adresse du fournisseur",
  ENTER_COMPANY_NAME: 'Saisir le nom de la société',
  ENTER_COMPANY_ADDRESS: "Saisir l'adresse de la société",
  ENTER_CITY: 'Saisir la ville',
  ENTER_SUPPLIER_WORK:
    'Veuillez saisir le numéro de téléphone de travail du fournisseur',
  ENTER_PARENT_EMAIL_ID: "Saisir l'adresse e-mail de la société mère",
  ENTER_PARENT_WORK_NUMBER:
    'Saisir le numéro de téléphone de travail de la société mère',
  ENTER_SUPPLIER_EMAIL_ID: "Saisir l'adresse e-mail du fournisseur",
  ENTER_SUPPLIER_TAX_1:
    "Saisir le numéro d'identification fiscal administrateur (1)",
  ENTER_SUPPLIER_TAX_2:
    "Saisir le numéro d'identification fiscal administrateur (2)",
  ENTER_SUPPLIER_TAX1_RATE: "Saisit Taux d'imposition (1) Fournisseur",
  ENTER_SUPPLIER_TAX2_RATE: "Saisit Taux d'imposition (2) Fournisseur",
  ENTER_DESCRIPTION: 'Saisir la description',
  PLEASE_ENTER_VALID_PARENT_POSTAL_CODE:
    'Veuillez saisir un code postal valide de la société mère',
  ENTER_POSTAL_CODE: 'Saisir le code postal',
  SELECT_STATE: 'Sélectionne État',
  SELECT_COUNTRY: 'Sélectionner Pays',
  SELECT_PARENT_COUNTRY: 'Sélectionner Pays de la société mère',
  SELECT_PARENT_STATE: 'Sélectionner État/Province de la société mère',
  SELECT_PAYMENT_METHOD: 'Sélectionner Méthode de paiement',
  SELECT_TERMS: 'Sélectionner Conditions',
  ENTER_CURRENT_PASSWORD: 'Saisir le mot de passe actuel',
  ENTER_NEW_PASSWORD: 'Saisir un nouveau mot de passe',
  ENTER_CONFIRM_PASSWORD: 'Saisir le mot de passe actuel',
  ENTER_SUBJECT: "Saisir l'objet",
  SELECT_SUPPLIER_STATE_PROVINCE: 'Sélectionner État/Province du fournisseur',
  SELECT_BILL_TO_COUNTRY: 'Sélectionner Facturer à ',
  SELECT_STATE_PROVINCE: 'Sélectionner État/Province',
  SELECT_SETUP_FEE: "Sélectionner Frais d'installation",
  SELECT_SUBSCRIPTION_PACK: "Sélectionner Forfait d'abonnement",
  SELECT_SUPPLIER_TAX1: 'Sélectionner Numéro fiscal administrateur (1)',
  SELECT_CITY: 'Sélectionner Ville',
  SELECT_POSTAL_CODE: 'Sélectionner Code postal',

  TAX_DESCRIPTION_IS_REQUIRED: 'La description de la taxe est requise',
  TAX_RATE_IS_REQUIRED: "Le taux d'imposition est requis",
  INVALID_IMG_DIMENTIONS:
    'Dimensions de l’image incorrectes. Veuillez utiliser 1280x720 ou 1920x1080',
  NEW_CONFIRM_PASSWORD_IS_NOT_SAME:
    'Les mots de passe ne correspondent pas. Veuillez réessayer.',
  PRICE_MUST_BE_GREATER_THAN_ZERO:
    'Veuillez saisir un code postal valide pour le magasin',
  QUANTITY_MUST_BE_GREATER_THAN_ZERO:
    'La quantité doit être supérieure à zéro.',
  REQUESTED_DELIVERY_DATE_IS_REQUIRED:
    'La date de livraison demandée est requise',
  REQUESTED_DELIVERY_DATE_MUST_IN_FUTURE:
    'La date de livraison demandée doit être ultérieure à aujourd’hui ',
  THIS_PRODUCT_IS_ALREADY_ADDED: 'Le produit a déjà été ajouté',
  QUANTITY_MUST_GREATER_THAN_ZERO: 'La quantité doit être supérieure à zéro',
  LOGGED_IN_SUCCESSFULLY: 'Connexion réussie',
  NO_DATA_FOUND_SUB_FOR_CATEGORY:
    'Aucune donnée trouvée pour la sous-catégorie ',
  NO_PRODUCTS_SELECTED_ASSIGNMENT:
    'Aucun produit sélectionné pour la mise à jour du statut',
  SELECT_ALL_ROWS_ASSIGNMENT:
    'Tous les produits ont été sélectionnés pour la mise à jour du statut ',
  DUE_DATE_IS_REQUIRED: 'La date d’échéance est requise',
  PRODUCTION_REPORT_IS_REQUIRED: 'Le rapport de production est requis',
  INGREDIENT_NAME_REQUIRED: "Le nom de l'ingrédient est requis",
  INGREDIENTS_IS_REQUIRED: "L'ingrédient est requis",
  PRODUCT_NAME_CANNOT_SAME: 'Le nom du produit ne peut pas être identique',
  INGREDIENTS_ALLREADY_ADDED: 'Cet ingrédient a déjà été ajouté',
  SHIPPING_METHOD_IS_REQUIRED: "La méthode d'expédition est requise",
  TAX_REQUIRED: 'Le numéro de taxe est requis',
  TAX_RATE_REQUIRED: "Le taux d'imposition est requis",
  NO_PRODUCTS_ASSIGNMENT: "Aucun produit sélectionné pour l'assignation",
  NO_PRODUCTS_SELECTED_UNASSIGNMENT:
    'Aucun produit sélectionné pour la désaffectation',
  FETCHING_INVOICE_DETAILS:
    'Récupération des détails de facturation en cours …',
  FETCHING_PRODUCTION_REPORT:
    'Récupération du rapport de production en cours ...',
  GETTING_REPORT: 'Chargement du rapport',
  CANCELLING_PRODUCTION: 'Annulation de la production en cours ...',
  NEW_PRODUCT_ADDED: 'Nouveau produit ajouté avec succès',
  SELECT_PRODUCTION_REPORT: 'Sélectionner Rapport de production',
  CONFIRMATION: 'Confirmation',
  ENTER_TAX_DESCRIPTION: 'Saisir la description de la taxe',
  ENTER_TAX_RATE: 'Saisir le taux de taxe',
  PLEASE_ENTER_ADMIN_TAX1:
    'Veuillez saisir le numéro fiscal administrateur (1)',
  PLEASE_ENTER_ADMIN_TAX2:
    'Veuillez saisir le numéro fiscal administrateur (2)',
  ENTER_ADMIN_TAX_1: 'Saisir le numéro fiscal administrateur (1)',
  ENTER_ADMIN_TAX_2: 'Saisir le numéro fiscal administrateur (2)',
  ADMIN_TAX1: 'Numéro fiscal administrateur (1)',
  ADMIN_TAX2: 'Numéro fiscal administrateur (2)',

  IMAGE_UPLOAD_MESSAGE:
    "Formats d'images acceptés : JPG, PNG, JPEG | Taille max fichier : 2MB | Résolution recommandée : 1280x720 pixels",

  READ_REPLY: 'FRead / Reply', //not used

  USA: 'États-Unis',
  CANADA: 'Canada',
  // Canada State--
  ONTARIO: 'Ontario',
  QUEBEC: 'Québec',
  NOVA_SCOTIA: 'Nouvelle-Écosse',
  NEW_BRUNSWICK: 'Nouveau-Brunswick',
  MANITOBA: 'Manitoba',
  BRITISH_COLUMBIA: 'Colombie Britannique',
  PRINCE_EDWARD_ISLAND: 'Île-du-Prince-Édouard',
  SASKATCHEWAN: 'Saskatchewan',
  ALBERTA: 'Alberta',
  NEWFOUNDLAND_AND_LABRADOR: 'Terre-Neuve-et-Labrador',

  // USA State--
  ALABAMA: 'Alabama',
  ALASKA: 'Alaska',
  ARIZONA: 'Arizona',
  ARKANSAS: 'Arkansas',
  CALIFORNIA: 'Californie',
  COLORADO: 'Colorado',
  CONNECTICUT: 'Connecticut',
  DELAWARE: 'Delaware',
  DISTRICT_OF_COLUMBIA: 'District de Colombia (Washington, D.C.)',
  FLORIDA: 'Florida',
  GEORGIA: 'Géorgie',
  HAWAII: 'Hawaï',
  IDAHO: 'Idaho',
  ILLINOIS: 'Illinois',
  INDIANA: 'Indiana',
  IOWA: 'Iowa',
  KANSAS: 'Kansas',
  KENTUCKY: 'Kentucky',
  LOUISIANA: 'Louisiane',
  MAINE: 'Maine',
  MARYLAND: 'Maryland',
  MASSACHUSETTS: 'Massachusetts',
  MICHIGAN: 'Michigan',
  MINNESOTA: 'Minnesota',
  MISSISSIPPI: 'Mississippi',
  MISSOURI: 'Missouri',
  MONTANA: 'Montana',
  NEBRASKA: 'Nebraska',
  NEVADA: 'Nevada',
  NEW_HAMPSHIRE: 'New Hampshire',
  NEW_JERSEY: 'New Jersey',
  NEW_MEXICO: 'Nouveau-Mexique',
  NEW_YORK: 'New York',
  NORTH_CAROLINA: 'Caroline du Nord',
  NORTH_DAKOTA: 'Dakota du Nord',
  OHIO: 'Ohio',
  OKLAHOMA: 'Oklahoma',
  OREGON: 'Oregon',
  PENNSYLVANIA: 'Pennsylvania',
  RHODE_ISLAND: 'Rhode Island',
  SOUTH_CAROLINA: 'Caroline du Sud',
  SOUTH_DAKOTA: 'Dakota du Sud',
  TENNESSEE: 'Tennessee',
  TEXAS: 'Texas',
  UTAH: 'Utah',
  VERMONT: 'Vermont',
  VIRGINIA: 'Virginia',
  WASHINGTON: 'Washington',
  WEST_VIRGINIA: 'Virginie-Occidentale',
  WISCONSIN: 'Wisconsin',
  WYOMING: 'Wyoming',

  B2B: 'B2B',
  B2C: 'B2C (à venir)',
  CHAINSTORE: 'Commerce de chaîne',
  SUPPLIER: 'Fournisseur',
  OTHER: 'Autre',

  // Payment Methods
  CREDIT_CARD: 'Carte de crédit',
  Interac: 'Interac',
  Line: 'FLine',
  Check: 'Vérifier',
  Other: 'Autre',
  TBA: 'À venir',
  POSTAL_CODE: 'ZIP/Code postal',
  SUPPLIER_DEACTIVATED_SUCCESS: 'Fournisseur désactivé avec succès',
  SUPPLIER_DEACTIVATION_FAILED: 'Échec désactivation Fournisseur',
  SUPPLIER_REACTIVATED_SUCCESS: 'Fournisseur réactivé avec succès',
  SUPPLIER_REACTIVATION_FAILED: 'Échec réactiovation Fournisseur',
  SUPPLIER_ADDED_SUCCESS: 'Fournisseur ajouté avec succès',
  SUPPLIER_ADDITION_FAILED: 'Échec ajout Fournisseur',
  SUPPLIER_UPDATED_SUCCESS: 'Fournisseur mis à jour avec succès',
  SUPPLIER_UPDATE_FAILED: 'Échec mise à jour Fournisseur',
  PROFILE_UPDATED_SUCCESS: 'Profil mis à jour avec succès',
  PROFILE_UPDATE_FAILED: 'Échec mise à jour Profil',
  POWERED_BY_ORDER_EZ: 'FPowered by Order-EZ.com',
};
